$(function() {
    let $loginForgotForm = $('.login-forgot-form');

    $('#showHidePassword').children('.input-group-addon').find('a').on('click', function (e) {
        e.preventDefault();
        if($(this).parent('.input-group-addon').prev('input').attr('type') === 'password') {
            $(this).parent('.input-group-addon').prev('input').attr('type', 'text');
            $(this).addClass('active');
        } else if($(this).parent('.input-group-addon').prev('input').attr('type') === 'text') {
            $(this).parent('.input-group-addon').prev('input').attr('type', 'password');
            $(this).removeClass('active');
        }
    });

    $('#showForgotPasswordModal').on('click', function (e) {
        e.preventDefault();
        $('#loginModal').modal('hide');
        $('#forgotModal').modal('show');
        $loginForgotForm.children('button[type="submit"]').addClass('disabled');
        $loginForgotForm.children('button[type="submit"]').attr('disabled', true);
    });

    $('#showLoginModal').on('click', function (e) {
        e.preventDefault();
        $('#loginModal').modal('show');
        $('#forgotModal').modal('hide');
        $loginForgotForm.children('button[type="submit"]').addClass('disabled');
        $loginForgotForm.children('button[type="submit"]').attr('disabled', true);
    });

    const submit = {
        show: function () {
            $loginForgotForm.children('button[type="submit"]').removeClass('disabled');
            $loginForgotForm.children('button[type="submit"]').removeAttr('disabled');
        },
        hide: function () {
            $loginForgotForm.children('button[type="submit"]').addClass('disabled');
            $loginForgotForm.children('button[type="submit"]').attr('disabled', true);
        },
    };

    $('#loginModal').on('shown.bs.modal', function () {
        let $currentModal = $(this);
        let $formInput = $currentModal.children($loginForgotForm).find('input');
        let $formCheck = $currentModal.children($loginForgotForm).find('.form-check');
        if(validateFields($currentModal)) {
            submit.show();
        } else {
            submit.hide();
        }
        $formInput.on('keyup', function () {
            if(validateFields($currentModal)) {
                submit.show();
            } else {
                submit.hide();
            }
        });
        $formCheck.on('click', function () {
            if(validateFields($currentModal)) {
                submit.show();
            } else {
                submit.hide();
            }
        });
    });

    $('#forgotModal').on('shown.bs.modal', function () {
        let $currentModal = $(this);
        let $formInput = $currentModal.children($loginForgotForm).find('input');
        if(validateFields($currentModal)) {
            submit.show();
        } else {
            submit.hide();
        }
        $formInput.on('keyup', function () {
            if(validateFields($currentModal)) {
                submit.show();
            } else {
                submit.hide();
            }
        });
    });


    function validateFields($modal) {
        let errors = {email: true, password: true, checkbox: true };
        $modal.children($loginForgotForm).find('.form-group').each(function() {
            switch ($(this).find('input').attr('type')) {
                case 'email': {
                    let $field = $(this).find('input[type="email"]');
                    errors.email = !!($field.hasAttr('required') && $field.val() !== '');
                    break;
                }
                case 'password': {
                    let $field = $(this).find('input[type="password"]');
                    errors.password = !!($field.hasAttr('required') && $field.val() !== '');
                    break;
                }
                case 'checkbox': {
                    //let $field = $(this).find('input[type="checkbox"]');
                    //errors.checkbox = !!($field.hasAttr('required') && $field.is(':checked'));
                }
            }
        });
        return !!(errors.email && errors.password && errors.checkbox);
    }

    $.fn.hasAttr = function(name) {
        return this.attr(name) !== undefined;
    };

    let forms = document.getElementsByClassName('login-forgot-form');
    Array.prototype.filter.call(forms, function(form) {
        form.addEventListener('submit', function(event) {
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                event.stopPropagation();
                let $thisForm = $(this);
                let formData = $thisForm.serializeArray();
                $.ajax({
                    url: window.ajax_url,
                    data: {
                        'action': 'user_login_or_forgot',
                        'data': formData,
                    },
                    type: 'POST',
                }).done(function (res) {
                    let response = JSON.parse(res);
                    $thisForm.find('.invalid-feedback').html('');
                    $thisForm.find('input').removeClass('is-invalid');
                    if(Object.keys(response.errors).length > 0) {
                        Object.keys(response.errors).map(function(k) {
                            switch (k) {
                                case 'invalid_email': {
                                    let $field = $thisForm.find('input[type="email"]').parent('.form-group');
                                    $field.children('.invalid-feedback').html(response.errors[k]);
                                    $field.children('input').addClass('is-invalid');
                                    break;
                                }
                                case 'incorrect_password': {
                                    let $field = $thisForm.find('input[type="password"]').parent('.input-group');
                                    $field.children('.invalid-feedback').html(response.errors[k]);
                                    $field.children('input').addClass('is-invalid');
                                    break;
                                }
                            }
                        });
                    } else {
                        if(response.type == "forgot"){
                            $('#resetModal').modal('show');
                            $('#forgotModal').modal('hide');
                        }else{
                            window.location = response.profile_url;
                        }
                    }
                }).fail(function (error) {
                    alert(error);
                });
            }
            form.classList.add('was-validated');
        }, false);
    });

    
    $('#reset_done').on('click', function (e) {
        e.preventDefault();
        $('#resetModal').modal('hide');
    });
});


// WEBPACK FOOTER //
// ./scripts/routes/login-forgot-modal.js